





























































































































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import FileUpload from "vue-upload-component";
import firebase from "firebase/app";
import "firebase/storage";
import { namespace } from "vuex-class";
import db from "@/db";

const user = namespace("User");
@Component({
  components: {
    FileUpload
  }
})
export default class Cv extends Vue {
  @Prop({ default: null })
  readonly oportunity!: any;
  @Prop({ default: "" })
  readonly oid!: string;
  @Prop({ default: "" })
  readonly color!: string;

  baseColors: string[] = [
    "orange-pastel",
    "red-pastel",
    "pink-pastel",
    "calypso-pastel"
  ];

  @Ref("cv_file") readonly cv_file!: HTMLInputElement;
  @Ref("upload") readonly upload!: FileUpload;
  files = [];
  uploading = false;

  @user.State
  public id!: string;

  get cvs(): [] {
    return this.$store.state.cvs;
  }
  created() {
    this.$store.dispatch("bindCvs", {
      userId: this.id,
      oportunityId: this.oid
    });
  }
  cvColor(index: number) {
    return this.color || this.baseColors[index % this.baseColors.length];
  }

  public chooseFile() {
    this.cv_file.click();
  }
  public async uploadCv(file: any, component: any) {
    this.uploading = true;
    console.log("Upload file: ");
    console.log(file);
    console.log("Upload component: ");
    console.log(component);
    const storageRef = firebase.storage().ref();
    const userCvRef = storageRef.child(
      `users/${this.id}/oportunities/${this.oid}/cv.pdf`
    );
    await userCvRef.put(file.file).then(snapshot => {
      console.log("Uploaded a blob or file!");
      console.log(snapshot);
      snapshot.ref.getDownloadURL().then(downloadURL => {
        console.log("File available at", downloadURL);
        db.collection("users")
          .doc(this.id)
          .collection("oportunities")
          .doc(this.oid)
          .collection("cvs")
          .add({
            name: file.name,
            createdAt: new Date(),
            url: downloadURL,
            status: 0
          })
          .then(doc => {
            this.$router.push({
              name: "CvResult",
              params: {
                oid: this.oid,
                cvid: doc.id
              }
            });
          });
        this.uploading = false;
      });
    });
  }
  public inputFilter(newFile: any, oldFile: any, prevent: Function) {
    console.log("New file: ");
    console.log(newFile);
    console.log("Old file: ");
    console.log(oldFile);
    if (!/\.(pdf?)$/i.test(newFile.name)) {
      console.log("invalid file");
      return prevent()
    }
    this.upload.active = true;
  }
}
